import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NavigationService } from '../shared/navigation/navigation.service';
import { UtilsService } from '../shared/services/utils.service';
import { Page } from '../shared/navigation/pages.model';
import { environment } from './../../environments/environment';
import { utils } from '../shared/helpers/utils';
import { take } from 'rxjs/operators';
/**
 * This class represents the lazy loaded PageComponent.
 */
@Component({
  selector: 'app-page',
  // templateUrl: 'page.component.html',
  // styleUrls: ['page.component.scss'],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PageComponent implements OnInit {
  public templates = ['simple.component', 'lazy1.component', 'lazy2.component', 'lazy3.component'];  
  public pageTitle: string;
  public pageContent: string;
  public pageName = environment.name;
  public gallery: any;
  public page: any;
  public children: Page[] = [];
  public banner = '';
  public cdn = environment.cdn;
  public template: string;
  public cmpInstance: any;

  constructor(private router: Router, private route: ActivatedRoute, private navigationService: NavigationService,
    private utilsService: UtilsService, private viewContainerRef: ViewContainerRef, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    // this.slug = this.router.url.substr(this.router.url.lastIndexOf('/') + 1);
    this.pageTitle = this.route.snapshot.data.name;
    if (this.route.snapshot.data.extra_field_3) {
      this.banner = this.cdn + '/pages/' + this.route.snapshot.data.photos_directory + '/' + this.route.snapshot.data.extra_field_3;
    }
    this.navigationService.navigation.subscribe(this.pageChanged);
    this.getContent();
  }

  getContent() {
    let cleanUrl = this.router.url.startsWith('/') ? this.router.url.substr(1) : this.router.url;
    cleanUrl = cleanUrl.split('/').join('+');
    this.navigationService.item(this.route.snapshot.data.id).pipe(take(1)).subscribe((result: any) => {
      this.pageContent = result.content;
      this.template = this.route.snapshot.data.template;
      this.getLazy();
      // if (this.template) {
      //   if (this.templates.includes(this.template)) {
      //     this.getLazy();
      //   } else {
      //     this.template = null;
      //   }
      // }
      this.cdr.detectChanges();
    }, error => {

    }
    );
  }

  getGallery(dir: string) {
    this.navigationService.gallery(dir).pipe(take(1)).subscribe((result: any) => {
      this.gallery = result.items;
      if (this.template) {
        this.getLazy();
      }
      this.cdr.detectChanges();
    }, error => {

    }
    );
  }

  async getLazy() {
    this.viewContainerRef.clear();
    let cmp: any;
    switch (this.template) {
      case 'lazy1.component':
        const { Lazy1Component } = await import('./lazy1.component');
        cmp = Lazy1Component;
        break;
      case 'lazy2.component':
        const { Lazy2Component } = await import('./lazy2.component');
        cmp = Lazy2Component;
        break;
      case 'lazy3.component':
        const { Lazy3Component } = await import('./lazy3.component');
        cmp = Lazy3Component;
        break;
      case 'downloads.component':
          const { DownloadsComponent } = await import('./downloads.component');
          cmp = DownloadsComponent;
          break;
      default:
        const { SimpleComponent } = await import('./simple.component');
        cmp = SimpleComponent;
        break;
    }
    if (cmp) {
      this.cmpInstance = this.viewContainerRef.createComponent(cmp);
      this.cmpInstance.instance.gallery = this.gallery;
      this.cmpInstance.instance.children = this.children;
      this.cmpInstance.instance.pageTitle = this.pageTitle;
      this.cmpInstance.instance.pageContent = this.pageContent;
      this.cmpInstance.changeDetectorRef.detectChanges();
    }
  }

  pageChanged = (menu: any) => {
    let c = JSON.parse(JSON.stringify(menu.footer));
    this.children = utils.filterData(c, '', '', '', this.route.snapshot.data.id, this.route.snapshot.data.parent);
    this.cdr.detectChanges();
  }


}
